import React, { useRef, useEffect } from 'react';

const CertificationLookup = ({
  services,
  formData,
  handleChange,
  handleLookup,
  lookupLoading,
  setError,
  isLookupDisabled
}) => {
  const certNumberRef = useRef(null);

  // Focus certification number input when service is selected
  useEffect(() => {
    if (formData.certification_service_id && certNumberRef.current) {
      certNumberRef.current.focus();
    }
  }, [formData.certification_service_id]);

  return (
    <div className="bg-white rounded-lg p-4">
      <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <div>
          <label htmlFor="certification_service_id" className="block text-sm font-medium text-gray-700 mb-1">
            Certification Service
          </label>
          <select
            id="certification_service_id"
            name="certification_service_id"
            value={formData.certification_service_id}
            onChange={handleChange}
            className="block w-full sm:w-48 border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
          >
            <option value="">Select a service</option>
            {services
              .filter(service => service.name !== 'Other')
              .map(service => (
                <option key={service.id} value={service.id}>
                  {service.name}
                </option>
              ))}
            {services
              .filter(service => service.name === 'Other')
              .map(service => (
                <option key={service.id} value={service.id}>
                  {service.name}
                </option>
              ))}
          </select>
        </div>

        <div>
          <label htmlFor="certification_number" className="block text-sm font-medium text-gray-700 mb-1">
            Cert/PCGS Number
          </label>
          <div className="flex">
            <input
              type="text"
              name="certification_number"
              id="certification_number"
              ref={certNumberRef}
              value={formData.certification_number}
              onChange={handleChange}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  if (!lookupLoading && !isLookupDisabled()) {
                    handleLookup();
                  }
                }
              }}
              className="block w-full sm:w-48 border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
            />
          </div>
        </div>

        {/* Show grade field only for NGC service */}
        {formData.certification_service_id && 
         services.find(s => s.id === parseInt(formData.certification_service_id))?.name === 'NGC' && (
          <div>
            <label htmlFor="ngc_rade" className="block text-sm font-medium text-gray-700 mb-1">
              Grade <span className="text-gray-500">(Required)</span>
            </label>
            <select
              name="ngc_grade"
              id="ngc_grade"
              value={formData.ngc_grade}
              onChange={handleChange}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  if (!lookupLoading && !isLookupDisabled()) {
                    handleLookup();
                  }
                }
              }}
              className="block w-full border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
            >
              <option value="">Select grade</option>
              <option value="Details">Details</option>
              <option value="Ancients">Ancients</option>
              {[...Array.from({ length: 11 }, (_, i) => 70 - i), 58,55,53,50,45,40,35,30,25,20,15,12,10,8,6,4,3,2,1].map(num => (
                <option key={num} value={num}>{num}</option>
              ))}
            </select>
          </div>
        )}

        <div className="sm:self-end">
          <button
            type="button"
            onClick={handleLookup}
            disabled={lookupLoading || isLookupDisabled()}
            className={`h-[38px] px-4 border border-transparent text-sm font-medium rounded-md shadow-sm text-white w-full sm:w-32 ${
              lookupLoading || isLookupDisabled()
                ? 'bg-indigo-400 cursor-not-allowed'
                : 'bg-indigo-600 hover:bg-indigo-700'
            } focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500`}
          >
            {lookupLoading ? 'Looking up...' : 'Look up'}
          </button>
        </div>
      </div>

    </div>
  );
};

export default CertificationLookup;
